<template>
  <div>
    <!-- Global Search Section -->
    <v-toolbar flat class="mb-3 global-search-toolbar">
      <v-flex xs12>
        <v-text-field
          @click="openGlobalSearchDialog"
          append-icon="search"
          class="inp-global-search"
          placeholder="Search all files and folders globally"
          :value="globalSearch"
          outlined
          dense
          hide-details
          readonly
        ></v-text-field>
      </v-flex>
    </v-toolbar>

    <!-- Global Search Results Indicator -->
    <v-alert
      v-if="showGlobalResults"
      type="info"
      outlined
      class="mb-3"
      dismissible
      @input="clearGlobalSearchResults"
    >
      <v-icon left>search</v-icon>
      Hiển thị kết quả tìm kiếm global cho: <strong>"{{ globalSearch }}"</strong>
      <v-btn @click="clearGlobalSearchResults" text small class="ml-2">
        Quay về folder hiện tại
      </v-btn>
    </v-alert>

  <div id="storage-item-page">
    <v-toolbar class="top-content" flat>
      <v-toolbar-title class="">
        <v-btn 
          v-if="parent_id" 
          @click="goBack" 
          icon 
          small 
          class="mr-2"
        >
          <v-icon>arrow_back</v-icon>
        </v-btn>
        <span class="body-1">{{ folderPath ? folderPath : 'Storage Item' }}</span>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      
      <!-- Search in current folder (moved right) -->
      <v-flex xs12 sm4 md3 class="mr-3">
        <v-text-field
          @click:clear="searchReference"
          append-icon="search"
          class="inp-search"
          clearable
          placeholder="Search in current folder"
          v-model="search"
          v-on:keydown="searchReference"
          outlined
          dense
          hide-details
        ></v-text-field>
      </v-flex>
      <!-- Filters popup trigger + clear-all -->
      <v-flex xs12 sm4 md2 class="mr-3 d-flex align-center">
        <v-menu
          v-model="filterMenu"
          :close-on-content-click="false"
          offset-y
          left
        >
          <template v-slot:activator="{ on }">
            <div class="d-flex align-center">
              <v-btn
                :color="hasActiveFilters ? 'primary' : 'grey'"
                :outlined="!hasActiveFilters"
                small
                v-on="on"
              >
                <v-icon left small>tune</v-icon>
                Filters
              </v-btn>
            </div>
          </template>
          <v-card style="min-width: 340px; max-width: 420px;">
            <v-card-text class="pa-3">
              <v-layout column>
                <!-- Kind -->
                <v-flex xs12 class="mb-2">
                  <v-select
                    v-model="itemTypeFilter"
                    :items="itemTypeOptions"
                    label="Kind"
                    clearable
                    outlined
                    dense
                    hide-details
                  ></v-select>
                </v-flex>
                <!-- Type -->
                <v-flex xs12 class="mb-2">
                  <v-select
                    v-model="typeFilter"
                    :items="typeFilterOptions"
                    label="Type"
                    clearable
                    outlined
                    dense
                    hide-details
                    :disabled="itemTypeFilter === 'FOLDER'"
                    :menu-props="{ maxHeight: '240px' }"
                  ></v-select>
                </v-flex>
                <!-- User -->
                <v-flex xs12 class="mb-2">
        <v-autocomplete
          v-model="userFilter"
          :items="filterUserList"
          :loading="loadingFilterUsers"
          label="Created By"
          item-text="text"
          item-value="value"
          multiple
          small-chips
          clearable
          outlined
          dense
          hide-details
        ></v-autocomplete>
                </v-flex>
                <!-- Date -->
                <v-flex xs12 class="mb-2 mt-2">
                  <v-menu
                    v-model="dateMenu"
                    :close-on-content-click="false"
                    bottom
                    left
                    offset-y
                    full-width
                  >
                    <v-btn
                      class="date-range-checked ma-0"
                      color="grey darken-3"
                      outline
                      slot="activator"
                      small
                      block
                      style="width: 100%; min-width: 260px; justify-content: flex-start; text-transform: none; border-top-left-radius: 0; border-top-right-radius: 0;"
                    >
                      <template v-if="dateFilterApplied && range.length === 2">
                        created at:
                        {{ new Date(range[0]) | morph-date("DD/MM/YYYY") }} — {{ new Date(range[1]) | morph-date("DD/MM/YYYY") }}
                      </template>
                      <template v-else>
                        created at: From — To
                      </template>
                    </v-btn>
                    <v-card>
                      <v-card-text>
                        <v-date-range
                          :labels="labels"
                          :options="dateRangeOptions"
                          @input="onDateRangeChange"
                          @cancelPicker="cancelDateRange"
                          @filterDateRange="applyDateRange"
                        ></v-date-range>
                        <v-layout class="mt-2" row wrap>
                          <v-spacer></v-spacer>
                          <v-btn small text color="primary" @click="clearDateRange">Clear</v-btn>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </v-flex>
              </v-layout>
              <v-layout justify-end>
                <v-btn text small color="grey" class="mr-2" @click="clearAllFilters">Reset</v-btn>
                <v-btn small color="primary" @click="applyAllFilters">Apply</v-btn>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-menu>
        <v-btn
          v-if="hasActiveFilters"
          icon
          small
          color="grey"
          class="ml-2"
          @click="clearAllFilters"
          :title="'Clear filters'"
        >
          <v-icon small>close</v-icon>
        </v-btn>
      </v-flex>
    </v-toolbar>

    <v-data-table
      :headers="headers"
      :items="storageItemData"
      :loading="loading"
      :pagination.sync="pagination"
      :rows-per-page-items="rowsPerPageItems"
      :total-items="totalItems"
      class="elevation-1 list-po"
      item-key="name"
    >
      <template slot="items" slot-scope="props">
        <tr style="color: rgba(0, 0, 0, 0.87) !important" @dblclick="handleDoubleClick(props.item)">
          <!-- <td class="text-xs-left">
            <v-chip 
              :color="props.item.type === 'FOLDER' ? 'orange' : 'blue'" 
              text-color="white" 
              small
            >
              {{ props.item.type }}
            </v-chip>
          </td> -->
          <td class="text-xs-left">
            <div class="name-cell">
              <v-icon 
                :color="getItemIconColor(props.item)" 
                class="name-icon mr-2"
                size="20"
              >
                {{ getItemIcon(props.item) }}
              </v-icon>
              {{ props.item.name }}
            </div>
          </td>
          <td class="text-xs-left">
            {{ props.item.created_by ? `${props.item.created_by.first_name} ${props.item.created_by.last_name}` : '' }}
          </td>
          <td class="text-xs-center">
            {{ props.item.createdAt | morph-date("DD/MM/YYYY HH:mm") }}
          </td>
          <td class="text-xs-center">
            {{ props.item.updatedAt | morph-date("DD/MM/YYYY HH:mm") }}
          </td>
          <td class="text-xs-center">
            <v-chip 
              :color="props.item.status == 'ACTIVE'? 'green' : 'grey'" 
              text-color="white" 
              small
            >
              {{ props.item.status == 'ACTIVE' ? 'ACTIVE' : 'INACTIVE' }}
            </v-chip>
          </td>
          <td class="text-xs-center">
            <v-icon @click="editItem(props.item)" color="primary" small class="mr-2">edit</v-icon>
            <v-icon @click="deleteItem(props.item)" color="error" small>delete</v-icon>
          </td>
        </tr>
      </template>

      <template v-slot:actions-prepend>
        <div class="actions-list actions-list-custom">
          <v-btn 
            color="primary" 
            @click="addFolder"
          >
            <v-icon left>folder_open</v-icon>
            Add Folder
          </v-btn>
          
          <v-btn 
            color="success"
            @click="uploadFile"
          >
            <v-icon left>cloud_upload</v-icon>
            Upload File
          </v-btn>
        </div>
      </template>

      <template slot="headers" slot-scope="props">
        <tr>
          <th
            v-for="header in props.headers"
            :key="header.value"
            :class="['sortable-header', header.sortable ? 'sortable' : '', header.align || '']"
            @click.stop="handleHeaderClick(header.value)"
            style="cursor: pointer; user-select: none;"
          >
            <span>{{ header.text }}</span>
            <span v-if="header.sortable && sortField === header.value">
              <v-icon small>
                {{ sortOrder === 'asc' ? 'arrow_upward' : (sortOrder === 'desc' ? 'arrow_downward' : '') }}
              </v-icon>
            </span>
          </th>
        </tr>
      </template>
    </v-data-table>

    <!-- File Preview Dialog -->
    <v-dialog v-model="fileDialog" max-width="1200px" max-height="90vh" width="85vw">
      <v-card>
        <v-card-title>
          <span class="headline">{{ selectedFile.name }}</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="fileDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <!-- Loading State -->
          <div v-if="selectedFile.fileType === 'loading'" class="text-center pa-4">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
            <p class="mt-2">Loading file...</p>
          </div>
          
          <!-- Error State -->
          <div v-else-if="selectedFile.fileType === 'error'" class="text-center pa-4">
            <v-icon size="64" color="error">error</v-icon>
            <p class="mt-2">Error loading file</p>
          </div>
          
          <!-- Video Preview -->
          <video 
            v-else-if="selectedFile.fileType === 'video'" 
            :src="selectedFile.url" 
            controls 
            style="width: 100%; max-height: 500px;"
          >
            Your browser does not support video playback.
          </video>
          
          <!-- Image Preview -->
          <img 
            v-else-if="selectedFile.fileType === 'image'" 
            :src="selectedFile.url" 
            style="width: 100%; max-height: 500px; object-fit: contain;"
            alt="Preview"
          />
          
          <!-- PDF Preview -->
          <iframe 
            v-else-if="selectedFile.fileType === 'pdf'" 
            :src="selectedFile.url" 
            style="width: 100%; height: 500px;"
            frameborder="0"
          ></iframe>
          
          <!-- Other File Types -->
          <div v-else class="text-center pa-4">
            <v-icon size="64" color="grey">insert_drive_file</v-icon>
            <p class="mt-2">{{ selectedFile.name }}</p>
            <v-btn v-if="selectedFile.url" color="primary" :href="selectedFile.url" target="_blank">
              Download File
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Add Folder Dialog -->
    <v-dialog v-model="addFolderDialog" max-width="500px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">{{ editingItem ? 'Edit Item' : 'Add New Folder' }}</span>
        </v-card-title>
        <v-form ref="addFolderForm" v-model="validFolderForm" lazy-validation>
          <v-card-text>
            <v-container>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="newFolder.name"
                    label="Folder Name"
                    :rules="folderNameRules"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <div class="status-row">
                    <span class="status-label">Status:</span>
                    <v-btn
                      @click="toggleFolderStatus"
                      :color="newFolder.status === 'ACTIVE' ? 'success' : 'grey'"
                      dark
                      small
                      class="status-button"
                    >
                      {{ newFolder.status }}
                    </v-btn>
                  </div>
                </v-flex>
                <v-flex xs12>
                  <v-autocomplete
                    v-model="newFolder.assign_users"
                    :items="userList"
                    :loading="loadingSelectUser"
                    label="Assign Users"
                    multiple
                    small-chips
                    clearable
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="cancelAddFolder">Cancel</v-btn>
            <v-btn @click="saveFolder" color="primary" :loading="savingFolder">Save</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- Delete Confirmation Dialog -->
    <v-dialog v-model="deleteDialog" max-width="400px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">{{ deleteSuccess ? 'Success' : 'Delete Confirmation' }}</span>
        </v-card-title>
        <v-card-text>
          <!-- Success State -->
          <div v-if="deleteSuccess" class="text-center pa-4">
            <v-icon size="64" color="success" class="mb-3">check_circle</v-icon>
            <p class="title">Item deleted successfully!</p>
            <p class="text--secondary">Item <strong>"{{ deletingItem ? deletingItem.name : '' }}"</strong> has been removed from the system.</p>
          </div>
          
          <!-- Confirmation State -->
          <div v-else>
            <p>Do you want to delete item <strong>"{{ deletingItem ? deletingItem.name : '' }}"</strong>?</p>
            <p class="text--secondary">This action cannot be undone.</p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="deleteSuccess" @click="closeDeleteDialog" color="primary">Close</v-btn>
          <template v-else>
            <v-btn @click="cancelDelete">Cancel</v-btn>
            <v-btn @click="confirmDelete" color="error" :loading="deletingItemData">Delete</v-btn>
          </template>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Upload Files Dialog -->
    <v-dialog v-model="uploadDialog" max-width="1200px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">Upload Files</span>
        </v-card-title>
        <v-card-text>
          <!-- Drag & Drop Area -->
          <div 
            class="drop-zone"
            :class="{ 'drag-over': isDragging }"
            @dragover.prevent="isDragging = true"
            @dragleave.prevent="isDragging = false"
            @drop.prevent="handleDrop"
            @click="triggerFileInput"
          >
            <v-icon size="48" color="grey">cloud_upload</v-icon>
            <p class="mt-2">Drag & drop files here or click to select</p>
            <p class="text--secondary">Maximum {{ MAX_FILES }} files, each file up to {{ maxFileSizeFormatted }}</p>
          </div>
          
          <!-- Hidden File Input -->
          <input 
            ref="fileInput" 
            type="file" 
            multiple 
            style="display: none;" 
            @change="handleFileSelect"
          />
          
          <!-- Files List -->
          <div v-if="uploadFiles.length > 0" class="mt-4">
            <h3 class="mb-3">Files to Upload ({{ uploadFiles.length }})</h3>
            <v-card 
              v-for="(file, index) in uploadFiles" 
              :key="index" 
              class="mb-3 file-item"
            >
              <v-card-text>
                <v-layout row wrap>
                  <!-- Left Column -->
                  <v-flex xs12 md6 class="pr-3">
                    <!-- File Info -->
                    <div class="file-info mb-3">
                      <v-icon left color="primary">insert_drive_file</v-icon>
                      <div class="file-details">
                        <div class="file-original-name">{{ file.originalName }}</div>
                        <div class="text--secondary caption">{{ formatFileSize(file.size) }}</div>
                      </div>
                    </div>
                    
                    <!-- Custom Name Input -->
                    <v-text-field
                      v-model="file.customName"
                      label="Custom Name"
                      dense
                      outlined
                      :rules="[v => !!v || 'Name is required']"
                    ></v-text-field>
                  </v-flex>
                  
                  <!-- Right Column -->
                  <v-flex xs12 md6 class="pl-3">
                    <!-- Status and Remove Button Row -->
                    <div class="status-remove-row mb-3">
                      <v-btn
                        @click="toggleFileStatus(index)"
                        :color="file.status === 'ACTIVE' ? 'success' : 'grey'"
                        dark
                        small
                        class="status-btn"
                      >
                        {{ file.status }}
                      </v-btn>
                      
                      <v-btn @click="removeFile(index)" icon small color="error" class="remove-btn">
                        <v-icon>close</v-icon>
                      </v-btn>
                    </div>
                    
                    <!-- Assign Users -->
                    <v-autocomplete
                      v-model="file.assign_users"
                      :items="userList"
                      label="Assign Users"
                      multiple
                      small-chips
                      dense
                      outlined
                      clearable
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="cancelUpload">Cancel</v-btn>
          <v-btn 
            @click="submitUpload" 
            color="primary" 
            :loading="uploadingFiles"
            :disabled="uploadFiles.length === 0"
          >
            Submit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Global Search Dialog -->
    <v-dialog v-model="globalSearchDialog" max-width="1000px" persistent>
      <v-card>
        <v-card-title>
          <v-icon left>search</v-icon>
          <span class="headline">Global Search</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeGlobalSearchDialog">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-layout row wrap align-center>
            <!-- Global Search Input (left, 2/4 width) -->
            <v-flex xs12 sm9 md10 class="pr-2">
              <v-text-field
                ref="globalSearchInput"
                v-model="globalSearchInput"
                @input="onGlobalSearchDialogInput"
                @click:clear="clearGlobalSearchDialog"
                append-icon="search"
                label="Global Search"
                clearable
                outlined
                dense
                hide-details
                
              ></v-text-field>
            </v-flex>
            <!-- Global Filters popup trigger -->
            <v-flex xs12 sm3 md2 class="d-flex justify-end">
              <v-menu
                class="global-filter-menu"
                v-model="globalFilterMenu"
                :close-on-content-click="false"
                offset-y
                left
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    :color="hasActiveGlobalFilters ? 'primary' : 'grey'"
                    :outlined="!hasActiveGlobalFilters"
                    small
                    v-on="on"
                  >
                    <v-icon left small>tune</v-icon>
                    Filters
                  </v-btn>
                </template>
                <v-card style="min-width: 320px; max-width: 420px;">
                  <v-card-text class="pa-3">
                    <v-layout column>
                      <v-flex xs12 class="mb-2">
                        <v-select
                          v-model="globalItemTypeFilter"
                          :items="itemTypeOptions"
                          label="Kind"
                          clearable
                          outlined
                          dense
                          hide-details
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 class="mb-2">
                        <v-select
                          v-model="globalTypeFilter"
                          :items="typeFilterOptions"
                          label="Type"
                          clearable
                          outlined
                          dense
                          hide-details
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 class="mb-2">
                        <v-autocomplete
                          v-model="globalUserFilter"
                          :items="filterUserList"
                          :loading="loadingFilterUsers"
                          label="Created By"
                          item-text="text"
                          item-value="value"
                          multiple
                          small-chips
                          clearable
                          outlined
                          dense
                          hide-details
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs12 class="mb-2 mt-2">
                        <v-menu
                          v-model="globalDateMenu"
                          :close-on-content-click="false"
                          bottom
                          left
                          offset-y
                          full-width
                        >
                          <v-btn
                            class="date-range-checked ma-0"
                            color="grey darken-3"
                            outline
                            slot="activator"
                            small
                            block
                            style="width: 100%; min-width: 260px; justify-content: flex-start; text-transform: none; border-top-left-radius: 0; border-top-right-radius: 0;"
                          >
                            <template v-if="globalDateFilterApplied && globalRange.length === 2">
                              created at:
                              {{ new Date(globalRange[0]) | morph-date("DD/MM/YYYY") }} — {{ new Date(globalRange[1]) | morph-date("DD/MM/YYYY") }}
                            </template>
                            <template v-else>
                              created at: From — To
                            </template>
                          </v-btn>
                          <v-card>
                            <v-card-text>
                              <v-date-range
                                :labels="labels"
                                :options="dateRangeOptions"
                                @input="onGlobalDateRangeChange"
                                @cancelPicker="cancelGlobalDateRange"
                                @filterDateRange="applyGlobalDateRange"
                              ></v-date-range>
                              <v-layout class="mt-2" row wrap>
                                <v-spacer></v-spacer>
                                <v-btn small text color="primary" @click="clearGlobalDateRange">Clear</v-btn>
                              </v-layout>
                            </v-card-text>
                          </v-card>
                        </v-menu>
                      </v-flex>
                    </v-layout>
                    <v-layout justify-end>
                      <v-btn text small color="grey" class="mr-2" @click="clearGlobalFilters">Reset</v-btn>
                      <v-btn small color="primary" @click="applyGlobalFilters">Apply</v-btn>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-menu>
            </v-flex>
          </v-layout>

          <!-- Loading State -->
          <div v-if="globalSearchLoading" class="text-center pa-4">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
            <p class="mt-2">Searching...</p>
          </div>

          <!-- No Results -->
          <div v-else-if="globalSearchInput && globalSearchDialogResults.length === 0 && !globalSearchLoading" class="text-center pa-4">
            <v-icon size="64" color="grey">search_off</v-icon>
            <p class="mt-2 title">No results found</p>
            <p class="text--secondary">Try different keywords</p>
          </div>

          <!-- Search Results -->
          <div v-else-if="globalSearchDialogResults.length > 0" class="search-results" @scroll="onGlobalSearchScroll">
            <h3 class="mb-3">Search Results ({{ globalSearchDialogResults.length }}) 
              <span v-if="globalSearchTotalPages > 1" class="text--secondary caption">
                - Page {{ globalSearchCurrentPage }} of {{ globalSearchTotalPages }}
              </span>
            </h3>
            <v-card 
              v-for="(item, index) in globalSearchDialogResults" 
              :key="index" 
              class="mb-2 search-result-item"
              @click="selectSearchResult(item)"
              hover
            >
              <v-card-text class="py-2">
                <v-layout row align-center>
                  <v-icon 
                    :color="getItemIconColor(item)" 
                    class="mr-3"
                    size="24"
                  >
                    {{ getItemIcon(item) }}
                  </v-icon>
                  <v-flex>
                    <div class="search-result-name">{{ item.name }}</div>
                    <div class="search-result-path text--secondary caption">
                      {{ buildItemPath(item) }}
                    </div>
                  </v-flex>
                  <v-chip 
                    :color="item.type === 'FOLDER' ? 'orange' : 'blue'" 
                    text-color="white" 
                    small
                    class="ml-2"
                  >
                    {{ item.type }}
                  </v-chip>
                </v-layout>
              </v-card-text>
            </v-card>
            
            <!-- Load More Section -->
            <div v-if="globalSearchHasNextPage || globalSearchLoadingMore" class="text-center pa-3">
              <v-btn 
                v-if="globalSearchHasNextPage && !globalSearchLoadingMore"
                @click="loadMoreGlobalSearchResults"
                color="primary"
                outlined
                small
              >
                <v-icon left>keyboard_arrow_down</v-icon>
                Load More
              </v-btn>
              
              <div v-if="globalSearchLoadingMore" class="text-center">
                <v-progress-circular indeterminate color="primary" size="24"></v-progress-circular>
                <p class="mt-2 caption">Loading more results...</p>
              </div>
            </div>
          </div>

          <!-- Initial State -->
          <div v-else class="text-center pa-4">
            <v-icon size="64" color="grey">search</v-icon>
            <p class="mt-2 title">Start typing to search</p>
            <p class="text--secondary">Search across all files and folders</p>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
  </div>
</template>

<script>
import StorageItemService from "../services/storage.item.service.js";
import UserService from "../services/user.service.js";
import {
  format,
  subDays,
  startOfToday,
  endOfToday,
  endOfTomorrow,
  startOfTomorrow,
  addDays,
  startOfMonth,
  getDaysInMonth,
  lastDayOfMonth,
  lastDayOfWeek,
} from "date-fns";
import { debounce, isEmpty } from "lodash";
import Vue from "vue";
import axios from "axios";
import VDateRange from "../components/DateRange.vue";

export default {
  components: {
    VDateRange,
  },
  data: () => ({
    storageItemService: new StorageItemService(),
    userService: new UserService(),
    loading: false,
    parent_id: null, // Will be set from route params
    parentOfCurrent: null, // Parent ID of current folder for back navigation
    folderPath: "", // Default title, will be updated with breadcrumb
    headers: [
      {
        text: "Name",
        value: "name",
        sortable: true,
        align: "text-xs-left",
      },
      {
        text: "Created By",
        value: "created_by",
        sortable: false,
        align: "text-xs-left",
      },
      {
        text: "Created At",
        value: "createdAt",
        align: "text-xs-center",
        sortable: true,
      },
      {
        text: "Updated At",
        value: "updatedAt",
        align: "text-xs-center",
        sortable: true,
      },
      {
        text: "Status",
        value: "status",
        align: "text-xs-center",
        sortable: false,
      },
      {
        text: "Action",
        sortable: false,
        align: "text-xs-center",
      },
    ],
    storageItemData: [],
    pagination: {
      rowsPerPage: 10,
      page: 1,
    },
    filterMenu: false,
    totalItems: 0,
    rowsPerPageItems: [10, 20, 50],
    search: null,
    // Date range filter (from/to)
    dateMenu: false,
    dateFilterApplied: false, // only send from/to when user applies
    range: [
      format(subDays(new Date(), 7), "YYYY-MM-DD"),
      format(new Date(), "YYYY-MM-DD"),
    ],
    rangTemp: [
      format(subDays(new Date(), 7), "YYYY-MM-DD"),
      format(new Date(), "YYYY-MM-DD"),
    ],
    labels: {
      start: "From Date",
      end: "To Date",
    },
    dateRangeOptions: {
      startDate: format(subDays(new Date(), 7), "YYYY-MM-DD"),
      endDate: format(new Date(), "YYYY-MM-DD"),
      format: "MM/DD/YYYY",
      maxDate: format(subDays(new Date(), -730), "YYYY-MM-DD"),
      dayInNextMonth: getDaysInMonth(
        new Date().setMonth(new Date().getMonth() + 1)
      ),
      presets: [
        {
          label: "Today",
          range: [
            format(startOfToday(), "YYYY-MM-DD"),
            format(endOfToday(), "YYYY-MM-DD"),
          ],
        },
        {
          label: "Tomorrow",
          range: [
            format(startOfTomorrow(), "YYYY-MM-DD"),
            format(endOfTomorrow(), "YYYY-MM-DD"),
          ],
        },
        {
          label: "Next Week",
          range: [
            format(
              addDays(
                lastDayOfWeek(new Date(), {
                  weekStartsOn: 1,
                }),
                1
              ),
              "YYYY-MM-DD"
            ),
            format(
              addDays(
                lastDayOfWeek(new Date(), {
                  weekStartsOn: 1,
                }),
                7
              ),
              "YYYY-MM-DD"
            ),
          ],
        },
        {
          label: "Next Month",
          range: [
            format(
              startOfMonth(new Date().setMonth(new Date().getMonth() + 1)),
              "YYYY-MM-DD"
            ),
            format(
              lastDayOfMonth(new Date().setMonth(new Date().getMonth() + 1)),
              "YYYY-MM-DD"
            ),
          ],
        },
      ],
    },
    globalSearch: '', // Global search across all files and folders
    globalSearchResults: [], // Store global search results
    showGlobalResults: false, // Flag to show global results
    // Global Search Dialog
    globalSearchDialog: false,
    globalSearchInput: '',
    globalSearchDialogResults: [],
    globalSearchLoading: false,
    globalFilterMenu: false,
    globalItemTypeFilter: null,
    globalDateMenu: false,
    globalDateFilterApplied: false,
    globalRange: [],
    globalRangTemp: [],
    // Pagination for global search
    globalSearchCurrentPage: 1,
    globalSearchTotalPages: 1,
    globalSearchHasNextPage: false,
    globalSearchLoadingMore: false,
    // File upload constants
    MAX_FILES: 10,
    MAX_FILE_SIZE: 1024 * 1024 * 1024, // 1GB in bytes
    // File preview dialog
    fileDialog: false,
    selectedFile: {
      name: '',
      url: '',
      fileType: ''
    },
    // Add folder dialog
    addFolderDialog: false,
    validFolderForm: true,
    savingFolder: false,
    editingItem: null, // Track item being edited
    newFolder: {
      name: '',
      status: 'INACTIVE',
      assign_users: []
    },
    folderNameRules: [
      v => !!v || 'Folder name is required',
      v => (v && v.length <= 100) || 'Folder name must be less than 100 characters'
    ],
    // User list for assign
    // Users for assign (dialogs)
    userList: [],
    loadingSelectUser: false,
    // Users for filter (global list)
    filterUserList: [],
    loadingFilterUsers: false,
    // Delete confirmation dialog
    deleteDialog: false,
    deletingItem: null,
    deletingItemData: false,
    deleteSuccess: false,
    // Upload files dialog
    uploadDialog: false,
    uploadFiles: [], // Array of files with metadata
    isDragging: false,
    uploadingFiles: false,
    uploadCancelSource: null,
    // Type filter
    itemTypeFilter: null,
    itemTypeOptions: [
      { text: 'Folder', value: 'FOLDER' },
      { text: 'File', value: 'FILE' },
    ],
    typeFilter: null,
    // File type filter mapped to mimetype values (key sent as mimetype)
    typeFilterOptions: [
      { text: 'Image', value: 'image' },           // matches mimetype prefix image/*
      { text: 'PDF', value: 'pdf' },   // exact PDF mimetype
      { text: 'Video', value: 'video' }            // matches mimetype prefix video/*
    ],
    // User filter
    userFilter: [],
    globalTypeFilter: null,
    globalUserFilter: [],
    sortField: null,
    sortOrder: null, // 'asc', 'desc', or null
    // UI state
  }),
  watch: {
    pagination: {
      handler() {
        this.getData();
      },
      deep: true,
    },
    searchUser() {
      this.querySearch();
    },
    globalSearchDialog(newVal) {
      if (newVal) {
        // When dialog opens, focus the input with multiple retry attempts
        this.$nextTick(() => {
          this.focusGlobalSearchInput();
        });
      }
    },
  },
  computed: {
    maxFileSizeFormatted() {
      return this.formatFileSize(this.MAX_FILE_SIZE);
    },
    hasActiveFilters() {
      return (
        !!this.itemTypeFilter ||
        !!this.typeFilter ||
        (this.userFilter && this.userFilter.length > 0) ||
        this.dateFilterApplied
      );
    },
    hasActiveGlobalFilters() {
      return (
        !!this.globalItemTypeFilter ||
        !!this.globalTypeFilter ||
        (this.globalUserFilter && this.globalUserFilter.length > 0) ||
        this.globalDateFilterApplied
      );
    },
  },
  created() {
    // Get parent_id from route params
    this.parent_id = this.$route.params.parent_id || null;
    
    // Get folder detail if parent_id exists
    if (this.parent_id) {
      this.getFolderDetail();
    }

    // Load user lists
    this.searchAssignUsers();
    this.searchFilterUsers();

    // Initial data load
    this.getData();
  },
  methods: {
    searchReference: debounce(function searchReference() {
      this.getData();
    }, 500),
    querySearch: debounce(function querySearch() {
      this.getData();
    }, 500),
    onGlobalSearchInput: debounce(function onGlobalSearchInput() {
      if (this.globalSearch && this.globalSearch.trim().length > 0) {
        this.performGlobalSearch();
      } else {
        this.clearGlobalSearchResults();
      }
    }, 500),
    onGlobalSearchDialogInput: debounce(function onGlobalSearchDialogInput() {
      if (this.globalSearchInput && this.globalSearchInput.trim().length > 0) {
        this.performGlobalSearchDialog();
      } else {
        this.globalSearchDialogResults = [];
      }
    }, 500),
    openGlobalSearchDialog() {
      this.globalSearchDialog = true;
      this.globalSearchInput = '';
      this.globalSearchDialogResults = [];
    },
    focusGlobalSearchInput() {
      // Try multiple methods to ensure focus works
      const attemptFocus = (attempt = 0) => {
        if (attempt > 5) return; // Max 5 attempts
        
        setTimeout(() => {
          if (this.$refs.globalSearchInput) {
            // Method 1: Focus through Vuetify component
            if (this.$refs.globalSearchInput.focus) {
              this.$refs.globalSearchInput.focus();
            }
            
            // Method 2: Focus through native input element
            if (this.$refs.globalSearchInput.$refs && this.$refs.globalSearchInput.$refs.input) {
              this.$refs.globalSearchInput.$refs.input.focus();
            }
            
            // Method 3: Query selector fallback
            const inputElement = this.$refs.globalSearchInput.$el.querySelector('input');
            if (inputElement) {
              inputElement.focus();
            }
            
            // Check if focus was successful, if not retry
            setTimeout(() => {
              const activeElement = document.activeElement;
              const isInputFocused = activeElement && (
                activeElement === this.$refs.globalSearchInput.$refs.input ||
                activeElement.tagName === 'INPUT'
              );
              
              if (!isInputFocused) {
                attemptFocus(attempt + 1);
              }
            }, 50);
          } else {
            attemptFocus(attempt + 1);
          }
        }, attempt * 50 + 100); // Increasing delay for each attempt
      };
      
      attemptFocus();
    },
    closeGlobalSearchDialog() {
      this.globalSearchDialog = false;
      this.globalSearchInput = '';
      this.globalSearchDialogResults = [];
      this.globalSearchLoading = false;
      this.globalSearchCurrentPage = 1;
      this.globalSearchTotalPages = 1;
      this.globalSearchHasNextPage = false;
      this.globalSearchLoadingMore = false;
      this.globalTypeFilter = null;
      this.globalUserFilter = [];
    },
    clearGlobalSearchDialog() {
      this.globalSearchInput = '';
      this.globalSearchDialogResults = [];
      this.globalSearchCurrentPage = 1;
      this.globalSearchTotalPages = 1;
      this.globalSearchHasNextPage = false;
    },
    performGlobalSearchDialog(loadMore = false) {
      if (!loadMore) {
        this.globalSearchLoading = true;
        this.globalSearchCurrentPage = 1;
      } else {
        this.globalSearchLoadingMore = true;
      }
      
      // Call the new global search API endpoint
      const params = {
        search: this.globalSearchInput.trim(),
        page: loadMore ? this.globalSearchCurrentPage + 1 : 1,
        limit: 10 // Changed to 10 as requested
      };
      if (this.globalTypeFilter) params.mimetype = this.globalTypeFilter;
      if (this.globalItemTypeFilter) params.type = this.globalItemTypeFilter;
      const globalCreators = (this.globalUserFilter || [])
        .map(u => (u && u.value) ? u.value : u)
        .filter(Boolean);
      if (globalCreators.length > 0) params.created_by = globalCreators;
      if (this.globalDateFilterApplied && this.globalRange && this.globalRange.length === 2) {
        params.from = this.globalRange[0];
        params.to = this.globalRange[1];
      }

      // Build query string
      const queryString = Object.keys(params)
        .map(key => `${key}=${encodeURIComponent(params[key])}`)
        .join('&');

      Vue.axios.get(`/storage-items/admin/globally?${queryString}`)
        .then((response) => {
          // Always stop loading first
          this.globalSearchLoading = false;
          this.globalSearchLoadingMore = false;
          
          if (response && response.data && response.data.statusCode === 200 && response.data.data && response.data.data.docs) {
            const newResults = response.data.data.docs || [];
            
            if (loadMore) {
              // Append new results to existing ones
              this.globalSearchDialogResults = [...this.globalSearchDialogResults, ...newResults];
              this.globalSearchCurrentPage = params.page;
            } else {
              // Replace with new results
              this.globalSearchDialogResults = newResults;
              this.globalSearchCurrentPage = 1;
            }
            
            // Update pagination info
            this.globalSearchTotalPages = response.data.data.totalPages || 1;
            this.globalSearchHasNextPage = response.data.data.hasNextPage || false;
          } else {
            if (!loadMore) {
              this.globalSearchDialogResults = [];
            }
          }
        })
        .catch(() => {
          // Always stop loading in catch
          this.globalSearchLoading = false;
          this.globalSearchLoadingMore = false;
          if (!loadMore) {
            this.globalSearchDialogResults = [];
          }
        })
        .finally(() => {
          // Ensure loading is always stopped
          this.globalSearchLoading = false;
          this.globalSearchLoadingMore = false;
        });
    },
    loadMoreGlobalSearchResults() {
      if (this.globalSearchHasNextPage && !this.globalSearchLoadingMore && !this.globalSearchLoading) {
        this.performGlobalSearchDialog(true);
      }
    },
    applyGlobalFilters() {
      this.globalFilterMenu = false;
      this.performGlobalSearchDialog();
    },
    clearGlobalFilters() {
      this.globalTypeFilter = null;
      this.globalUserFilter = [];
      this.globalItemTypeFilter = null;
      this.globalDateFilterApplied = false;
      this.globalRange = [];
      this.globalRangTemp = [];
      this.globalDateMenu = false;
      this.globalFilterMenu = false;
      this.performGlobalSearchDialog();
    },
    onGlobalDateRangeChange(range) {
      this.globalRangTemp = range;
    },
    cancelGlobalDateRange() {
      this.globalRangTemp = this.globalRange;
      this.globalDateMenu = false;
    },
    applyGlobalDateRange() {
      if (this.globalRangTemp && this.globalRangTemp.length === 2) {
        this.globalRange = this.globalRangTemp;
        this.globalDateFilterApplied = true;
      }
      this.globalDateMenu = false;
    },
    clearGlobalDateRange() {
      this.globalDateFilterApplied = false;
      this.globalRange = [];
      this.globalRangTemp = [];
      this.globalDateMenu = false;
    },
    applyAllFilters() {
      // If selecting Folder, remove file type filter
      if (this.itemTypeFilter === 'FOLDER') {
        this.typeFilter = null;
      }
      this.filterMenu = false;
      this.getData();
    },
    clearAllFilters() {
      this.itemTypeFilter = null;
      this.typeFilter = null;
      this.userFilter = [];
      this.dateFilterApplied = false;
      this.range = [];
      this.rangTemp = [];
      this.filterMenu = false;
      this.getData();
    },
    onDateRangeChange(range) {
      this.rangTemp = range;
    },
    cancelDateRange() {
      this.rangTemp = this.range;
      this.dateMenu = false;
    },
    applyDateRange() {
      // Apply selected temp range to active range and refresh data
      if (this.rangTemp && this.rangTemp.length === 2) {
        this.range = this.rangTemp;
        this.dateFilterApplied = true;
      }
      this.dateMenu = false;
    },
    clearDateRange() {
      // Clear applied date filter
      this.dateFilterApplied = false;
      this.range = [];
      this.rangTemp = [];
      this.dateMenu = false;
    },
    onGlobalSearchScroll(event) {
      const element = event.target;
      const threshold = 100; // Load more when 100px from bottom
      
      if (element.scrollTop + element.clientHeight >= element.scrollHeight - threshold) {
        this.loadMoreGlobalSearchResults();
      }
    },
    selectSearchResult(item) {
      // Close dialog first
      this.closeGlobalSearchDialog();
      
      if (item.type === 'FOLDER') {
        // Navigate to folder
        this.parent_id = item._id;
        this.$router.push(`/storage-item/${item._id}`);
        
        // Get folder detail for breadcrumb
        this.getFolderDetail();
        
        // Reload table data
        this.getData();
      } else if (item.type === 'FILE') {
        // Open file preview
        this.openFilePreview(item);
      }
    },
    buildItemPath(item) {
      // Build path from parents array
      if (item.parents && item.parents.length > 0) {
        // Sort parents by level (descending: highest level/root first)
        const sortedParents = [...item.parents].sort((a, b) => b.level - a.level);
        const pathParts = sortedParents.map(parent => parent.name);
        // Truncate if path is too long (more than 4 parts including current item)
        if (pathParts.length > 4) {
          const truncatedParts = [
            pathParts[0], // Root folder
            '...', // Ellipsis
            pathParts[pathParts.length - 2], // Parent folder
            pathParts[pathParts.length - 1] // Current item
          ];
          return truncatedParts.join(' / ');
        } else {
          return pathParts.join(' / ');
        }
      }
      // If no parents, return empty string
      return '';
    },
    getSortedParents(item) {
      if (item.parents && item.parents.length > 0) {
        // Create copy to avoid mutation that triggers infinite updates
        return [...item.parents].sort((a, b) => a.level - b.level);
      }
      return [];
    },
    performGlobalSearch() {
      this.loading = true;
      
      // Call API for global search (without parent_id to search all)
      const params = {
        search: this.globalSearch.trim(),
        page: 1,
        limit: 50, // Show more results for global search
        global: true // Flag to indicate this is a global search
      };

      this.storageItemService.getList(params).then((res) => {
        this.loading = false;
        if (res && res.docs) {
          this.globalSearchResults = res.docs || [];
          this.showGlobalResults = true;
          
          // Replace current table data with search results
          this.storageItemData = this.globalSearchResults;
          this.totalItems = res.totalDocs || 0;
          
          // Reset pagination to first page
          this.pagination.page = 1;
        }
      }).catch(() => {
        this.loading = false;
        this.clearGlobalSearchResults();
      });
    },
    clearGlobalSearch() {
      this.globalSearch = '';
      this.clearGlobalSearchResults();
    },
    clearGlobalSearchResults() {
      this.showGlobalResults = false;
      this.globalSearchResults = [];
      // Reload current folder data
      this.getData();
    },
    getFolderDetail() {
      if (!this.parent_id) return;
      
      // Call API to get folder detail
      Vue.axios.get(`/storage-items/admin/${this.parent_id}/detail`)
        .then(response => {
          if (response.data && response.data.statusCode === 200) {
            this.buildFolderPath(response.data.data);
          }
        })
        .catch(() => {
          // Handle error silently or show user-friendly message
          this.folderPath = "Root";
        });
    },
    buildFolderPath(folderData) {
      let pathParts = [];
      
      // Store parent_id of current folder for back navigation
      this.parentOfCurrent = folderData.parent_id;
      
      // Sort parents by level (high to low for correct order)
      if (folderData.parents && folderData.parents.length > 0) {
        const sortedParents = folderData.parents.sort((a, b) => b.level - a.level);
        pathParts = sortedParents.map(parent => parent.name);
      }
      
      // Add current folder name
      pathParts.push(folderData.name);
      
      // Truncate path if too long (more than 3 parts)
      if (pathParts.length > 3) {
        const truncatedParts = [
          pathParts[0], // First folder
          '...', // Ellipsis
          pathParts[pathParts.length - 2], // Second to last folder
          pathParts[pathParts.length - 1] // Current folder
        ];
        this.folderPath = `${truncatedParts.join(' / ')}`;
      } else {
        // Create full breadcrumb path
        this.folderPath = `${pathParts.join(' / ')}`;
      }
    },
    goBack() {
      // Navigate to parent folder
      if (this.parentOfCurrent) {
        // Go to parent folder
        this.$router.push(`/storage-item/${this.parentOfCurrent}`);
      } else {
        // Go to root level
        this.$router.push('/storage-item');
      }
      
      // Update parent_id and reload data
      this.parent_id = this.parentOfCurrent;
      
      // Get folder detail for new parent if exists
      if (this.parent_id) {
        this.getFolderDetail();
      } else {
        // Reset to root level
        this.folderPath = "";
        this.parentOfCurrent = null;
      }
      
      // Reload table data
      this.getData();
    },
    getData() {
      this.showGlobalResults = false;
      this.loading = true;
      let params = {
        page: this.pagination.page,
        limit: this.pagination.rowsPerPage,
      };
      if (this.parent_id) {
        params.parent_id = this.parent_id;
      }
      if (!isEmpty(this.search)) params.search = this.search;
      if (this.typeFilter) params.mimetype = this.typeFilter;
      if (this.itemTypeFilter) params.type = this.itemTypeFilter;
      if (this.dateFilterApplied && this.range && this.range.length === 2) {
        params.from = this.range[0];
        params.to = this.range[1];
      }
      const creatorFilter = (this.userFilter || [])
        .map(u => (u && u.value) ? u.value : u)
        .filter(Boolean);
      if (creatorFilter.length > 0) params.created_by = creatorFilter;
      // Pass sorting as separate parameters so backend receives them individually
      if (this.sortField) params.sortField = this.sortField;
      if (this.sortOrder) params.sortOrder = this.sortOrder;
      this.storageItemService.getList(params).then((res) => {
        this.loading = false;
        if (res && res.docs) {
          this.storageItemData = res.docs || [];
          this.totalItems = res.totalDocs || 0;
        }
      });
    },
    async editItem(item) {
      this.editingItem = item;
      try {
        // Load item details from API
        const response = await Vue.axios.get(`/storage-items/admin/${item._id}/detail`);
        if (response.data && response.data.statusCode === 200) {
          const itemData = response.data.data;
          
          // Fill form with existing data
          this.newFolder = {
            name: itemData.name || '',
            status: itemData.status || 'INACTIVE',
            assign_users: itemData.assign_users || []
          };
          
          // Load users and open dialog
          this.searchAssignUsers();
          this.addFolderDialog = true;
        } else {
          alert('Không thể tải thông tin item');
        }
      } catch (error) {
        // Handle error silently or show user-friendly message
        alert('Lỗi khi tải thông tin item');
      }
    },
    deleteItem(item) {
      // Reset success state and open delete confirmation dialog
      this.deleteSuccess = false;
      this.deletingItem = item;
      this.deleteDialog = true;
    },
    cancelDelete() {
      this.deleteDialog = false;
      this.deletingItem = null;
      this.deleteSuccess = false;
    },
    closeDeleteDialog() {
      this.deleteDialog = false;
      this.deletingItem = null;
      this.deleteSuccess = false;
    },
    confirmDelete() {
      if (!this.deletingItem) return;
      
      this.deletingItemData = true;
      
      // Call API to delete item
      Vue.axios.delete(`/storage-items/admin/${this.deletingItem._id}/delete`).then((response) => {
        this.deletingItemData = false;
        if (response.data && response.data.statusCode === 200) {
          // Show success state in dialog
          this.deleteSuccess = true;
          
          // Reload table
          this.getData();
          
          // Auto close after 1 seconds
          setTimeout(() => {
            this.closeDeleteDialog();
          }, 1000);
        } else {
          alert('Lỗi khi xóa item: ' + (response.data.message || 'Unknown error'));
        }
      }).catch((error) => {
        this.deletingItemData = false;
        const errorMessage = error.response && error.response.data && error.response.data.message 
          ? error.response.data.message 
          : 'Network error';
        alert('Lỗi khi xóa item: ' + errorMessage);
      });
    },
    handleDoubleClick(item) {
      if (item.type === 'FOLDER') {
        // Navigate to folder and reload data
        this.parent_id = item._id;
        this.$router.push(`/storage-item/${item._id}`);
        
        // Get folder detail for breadcrumb
        this.getFolderDetail();
        
        // Reload table data
        this.getData();
      } else if (item.type === 'FILE') {
        // Open file preview dialog
        this.openFilePreview(item);
      }
    },
    openFilePreview(file) {
      if (!file.key) {
        alert('File key not found');
        return;
      }

      // Show loading
      this.fileDialog = true;
      this.selectedFile = {
        name: file.name,
        url: '',
        fileType: 'loading'
      };

      // Call API to get file data
      Vue.axios.get(`/storage-items/file-data?key=${file.key}`)
        .then(response => {
          if (response.data && response.data.statusCode === 200) {
            const fileData = response.data.data;
            
            // Set selected file data
            this.selectedFile = {
              name: fileData.name,
              url: fileData.url,
              fileType: this.getFileTypeFromMimeType(fileData.mimetype),
              mimetype: fileData.mimetype,
              size: fileData.size
            };
          } else {
            // Handle error
            this.selectedFile = {
              name: file.name,
              url: '',
              fileType: 'error'
            };
          }
        })
        .catch(() => {
          this.selectedFile = {
            name: file.name,
            url: '',
            fileType: 'error'
          };
        });
    },
    getFileTypeFromMimeType(mimetype) {
      if (!mimetype) return 'other';
      
      // Video types
      if (mimetype.startsWith('video/')) {
        return 'video';
      }
      
      // Image types  
      if (mimetype.startsWith('image/')) {
        return 'image';
      }
      
      // PDF
      if (mimetype === 'application/pdf') {
        return 'pdf';
      }
      
      // Other types
      return 'other';
    },
    addFolder() {
      // Reset form and editing state
      this.editingItem = null;
      this.newFolder = {
        name: '',
        status: 'INACTIVE',
        assign_users: []
      };
      this.addFolderDialog = true;
      
      // Load users when popup opens (assign list)
      this.searchAssignUsers();
    },
    cancelAddFolder() {
      this.addFolderDialog = false;
      this.editingItem = null; // Reset editing state
      this.$refs.addFolderForm.reset();
    },
    saveFolder() {
      if (this.$refs.addFolderForm.validate()) {
        this.savingFolder = true;
        
        const folderData = {
          name: this.newFolder.name,
          status: this.newFolder.status,
          assign_users: this.newFolder.assign_users,
          parent_id: this.parent_id || null
        };

        // Determine if we are creating or updating
        if (this.editingItem) {
          // Update existing item
          const dataUpdate = {
            name: this.newFolder.name,
            status: this.newFolder.status,
            assign_users: this.newFolder.assign_users,
          };
          Vue.axios.patch(`/storage-items/admin/${this.editingItem._id}/update`, dataUpdate).then((response) => {
            this.savingFolder = false;
            if (response.data && (response.data.statusCode === 200 || response.data.success)) {
              this.addFolderDialog = false;
              this.editingItem = null; // Reset editing state
              this.getData(); // Reload table
              this.$refs.addFolderForm.reset();
            } else {
              alert('Error updating item: ' + (response.data.message || 'Unknown error'));
            }
          }).catch((error) => {
            this.savingFolder = false;
            const errorMessage = error.response && error.response.data && error.response.data.message 
              ? error.response.data.message 
              : 'Network error';
            alert('Error updating item: ' + errorMessage);
          });
        } else {
          // Create new folder
          Vue.axios.post('/storage-items/admin/folders', folderData).then((response) => {
            this.savingFolder = false;
            if (response.data && response.data.statusCode === 200) {
              this.addFolderDialog = false;
              this.getData(); // Reload table
              this.$refs.addFolderForm.reset();
            } else {
              alert('Error creating folder: ' + (response.data.message || 'Unknown error'));
            }
          }).catch((error) => {
            this.savingFolder = false;
            const errorMessage = error.response && error.response.data && error.response.data.message 
              ? error.response.data.message 
              : 'Network error';
            alert('Error creating folder: ' + errorMessage);
          });
        }
      }
    },
    
    searchAssignUsers() {
      this.loadingSelectUser = true;

      // Build URL for storage items users API (scoped by parent)
      let url = `/storage-items/admin/users-by-parent`;
      if (this.parent_id) {
        url += `?parent_id=${this.parent_id}`;
      }

      Vue.axios.get(url).then((res) => {
        if (res && res.data && res.data.statusCode === 200) {
          const users = res.data.data || [];
          this.userList = users.map((e) => ({
            text: [e.first_name, e.last_name].join(" ") + " <" + e.email + ">",
            value: e._id,
          }));
        } else {
          this.userList = [];
        }
        this.loadingSelectUser = false;
      }).catch(() => {
        this.userList = [];
        this.loadingSelectUser = false;
      });
    },
    searchFilterUsers(query) {
      this.loadingFilterUsers = true;

      const params = {
        limit: 500,
      };
      if (query && query.search) {
        params.search = query.search;
      }

      this.userService.getList(params).then((res) => {
        if (res && res.docs) {
          this.filterUserList = res.docs.map((e) => ({
            text: [e.first_name, e.last_name].join(" ") + " <" + e.email + ">",
            value: e._id,
          }));
        } else {
          this.filterUserList = [];
        }
        this.loadingFilterUsers = false;
      }).catch(() => {
        this.filterUserList = [];
        this.loadingFilterUsers = false;
      });
    },
    uploadFile() {
      // Reset upload state and open upload dialog
      this.uploadFiles = [];
      this.uploadDialog = true;
      
      // Load users when popup opens (assign list)
      this.searchAssignUsers();
    },
    cancelUpload() {
      if (this.uploadCancelSource) {
        this.uploadCancelSource.cancel('Upload cancelled by user');
        this.uploadCancelSource = null;
      }
      this.uploadingFiles = false;
      this.uploadDialog = false;
      this.uploadFiles = [];
      this.isDragging = false;
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileSelect(event) {
      const files = Array.from(event.target.files);
      this.addFiles(files);
      // Reset input so same file can be selected again
      event.target.value = '';
    },
    handleDrop(event) {
      this.isDragging = false;
      const files = Array.from(event.dataTransfer.files);
      this.addFiles(files);
    },
    addFiles(files) {
      // Validate file count
      const remainingSlots = this.MAX_FILES - this.uploadFiles.length;
      if (files.length > remainingSlots) {
        alert(`Chỉ có thể upload tối đa ${this.MAX_FILES} files. Bạn có thể thêm ${remainingSlots} files nữa.`);
        return;
      }
      
      // Validate file sizes and add valid files
      const validFiles = [];
      const invalidFiles = [];
      
      files.forEach(file => {
        if (file.size > this.MAX_FILE_SIZE) {
          invalidFiles.push(file.name);
        } else {
          validFiles.push(file);
        }
      });
      
      // Show error for invalid files
      if (invalidFiles.length > 0) {
        alert(`Các files sau vượt quá 1GB:\n${invalidFiles.join('\n')}`);
      }
      
      // Add valid files
      validFiles.forEach(file => {
        const fileObj = {
          file: file,
          originalName: file.name,
          customName: file.name.split('.')[0], // Remove extension for default name
          status: 'INACTIVE',
          assign_users: [],
          size: file.size
        };
        this.uploadFiles.push(fileObj);
      });
    },
    removeFile(index) {
      this.uploadFiles.splice(index, 1);
    },
    toggleFileStatus(index) {
      this.uploadFiles[index].status = this.uploadFiles[index].status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE';
    },
    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },
    getItemIcon(item) {
      if (item.type === 'FOLDER') {
        return 'folder';
      }
      
      // For files, check mimetype
      if (item.mimetype) {
        if (item.mimetype.startsWith('image/')) {
          return 'image';
        }
        if (item.mimetype.startsWith('video/')) {
          return 'movie';
        }
        if (item.mimetype === 'application/pdf') {
          return 'picture_as_pdf';
        }
        if (item.mimetype.startsWith('audio/')) {
          return 'audiotrack';
        }
        if (item.mimetype.includes('text/') || item.mimetype.includes('document')) {
          return 'description';
        }
        if (item.mimetype.includes('spreadsheet') || item.mimetype.includes('excel')) {
          return 'grid_on';
        }
        if (item.mimetype.includes('presentation') || item.mimetype.includes('powerpoint')) {
          return 'slideshow';
        }
        if (item.mimetype.includes('zip') || item.mimetype.includes('rar') || item.mimetype.includes('archive')) {
          return 'archive';
        }
      }
      
      // Default file icon
      return 'insert_drive_file';
    },
    getItemIconColor(item) {
      if (item.type === 'FOLDER') {
        return '#FFA726'; // Orange
      }
      
      // For files, color based on mimetype
      if (item.mimetype) {
        if (item.mimetype.startsWith('image/')) {
          return '#66BB6A'; // Green
        }
        if (item.mimetype.startsWith('video/')) {
          return '#EF5350'; // Red
        }
        if (item.mimetype === 'application/pdf') {
          return '#F44336'; // Red
        }
        if (item.mimetype.startsWith('audio/')) {
          return '#AB47BC'; // Purple
        }
        if (item.mimetype.includes('text/') || item.mimetype.includes('document')) {
          return '#42A5F5'; // Blue
        }
        if (item.mimetype.includes('spreadsheet') || item.mimetype.includes('excel')) {
          return '#66BB6A'; // Green
        }
        if (item.mimetype.includes('presentation') || item.mimetype.includes('powerpoint')) {
          return '#FF7043'; // Deep Orange
        }
        if (item.mimetype.includes('zip') || item.mimetype.includes('rar') || item.mimetype.includes('archive')) {
          return '#8D6E63'; // Brown
        }
      }
      
      // Default file color
      return '#757575'; // Grey
    },
    submitUpload() {
      if (this.uploadFiles.length === 0) return;
      
      // Double-check file count limit
      if (this.uploadFiles.length > this.MAX_FILES) {
        alert(`Không thể upload quá ${this.MAX_FILES} files cùng lúc`);
        return;
      }
      
      // Double-check file size limits
      const oversizedFiles = this.uploadFiles.filter(f => f.size > this.MAX_FILE_SIZE);
      if (oversizedFiles.length > 0) {
        alert(`Các files sau vượt quá 1GB:\n${oversizedFiles.map(f => f.originalName).join('\n')}`);
        return;
      }
      
      // Validate all files have custom names
      const invalidFiles = this.uploadFiles.filter(f => !f.customName.trim());
      if (invalidFiles.length > 0) {
        alert('Vui lòng nhập tên cho tất cả files');
        return;
      }
      
      this.uploadingFiles = true;
      if (this.uploadCancelSource) {
        this.uploadCancelSource.cancel('Previous upload cancelled');
      }
      this.uploadCancelSource = axios.CancelToken.source();
      
      // Prepare FormData
      const formData = new FormData();
      
      // Add files
      this.uploadFiles.forEach(fileObj => {
        formData.append('files', fileObj.file);
      });
      
      // Add custom names array
      const customNames = this.uploadFiles.map(f => f.customName);
      formData.append('customNames', JSON.stringify(customNames));
      
      // Add status array
      const statusArr = this.uploadFiles.map(f => f.status);
      formData.append('statusArr', JSON.stringify(statusArr));
      
      // Add assign users array
      const assign_users = this.uploadFiles.map(f => f.assign_users);
      formData.append('assign_users', JSON.stringify(assign_users));
      
      // Add parent_id only if it has value (not null)
      if (this.parent_id) {
        formData.append('parent_id', this.parent_id);
      }
      
      // Call API
      const requestConfig = {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        cancelToken: this.uploadCancelSource.token,
      };

      Vue.axios.post('/storage-items/admin/files', formData, requestConfig).then((response) => {
        if (response.data && response.data.statusCode === 200) {
          this.uploadDialog = false;
          this.uploadFiles = [];
          this.getData(); // Reload table
        } else {
          alert('Lỗi khi upload files: ' + (response.data.message || 'Unknown error'));
        }
      }).catch((error) => {
        if (axios.isCancel(error)) {
          // Request cancelled by user; no alert needed
          return;
        }
        const errorMessage = error.response && error.response.data && error.response.data.message 
          ? error.response.data.message 
          : 'Network error';
        alert('Lỗi khi upload files: ' + errorMessage);
      }).finally(() => {
        this.uploadingFiles = false;
        this.uploadCancelSource = null;
      });
    },
    toggleFolderStatus() {
      this.newFolder.status = this.newFolder.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE';
    },
    handleHeaderClick(field) {
      if (!['name', 'createdAt', 'updatedAt'].includes(field)) return;
      if (this.sortField !== field) {
        this.sortField = field;
        this.sortOrder = 'asc';
      } else if (this.sortOrder === 'asc') {
        this.sortOrder = 'desc';
      } else if (this.sortOrder === 'desc') {
        this.sortField = null;
        this.sortOrder = null;
      } else {
        this.sortOrder = 'asc';
      }
      this.getData();
    },
  },
};
</script>
<style>
.v-input .v-input__slot {
  margin: 0 !important;
}

.top-content {
  flex-wrap: wrap;
}

.folder-path-title {
  font-size: 18px !important; /* Smaller than default title */
  font-weight: 500 !important;
  line-height: 1.2 !important;
}

#storage-item-page .v-datatable__actions {
  position: relative;
}

@media screen and (min-width: 1080px) {
  .actions-list-custom {
    right: calc(50% - 100px) !important;
    left: auto !important;
  }
}

.actions-list-custom {
  position: absolute !important;
  top: 5px !important;
}

.actions-list-custom .v-btn {
  margin-right: 12px !important;
}

.actions-list-custom .v-btn:last-child {
  margin-right: 0 !important;
}

.status-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 0;
}

.status-label {
  font-size: 16px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.87);
  min-width: 60px;
  flex-shrink: 0;
}

.status-switch {
  flex-shrink: 0;
  margin-top: 0 !important;
  padding-top: 0 !important;
  margin-right: 8px !important;
  max-width: 120px !important;
}

.status-switch .v-input__control {
  width: auto !important;
}

.status-switch .v-input__slot {
  min-width: auto !important;
}

.status-button {
  flex-shrink: 0;
  min-width: 90px !important;
  height: 32px !important;
  margin-right: 8px !important;
  font-weight: 600 !important;
  letter-spacing: 0.5px !important;
  transition: all 0.3s ease !important;
  border-radius: 20px !important;
}

.status-button:hover {
  transform: scale(1.02) !important;
  box-shadow: 0 4px 8px rgba(0,0,0,0.2) !important;
}

.status-chip {
  flex-shrink: 0;
  min-width: 80px;
}

/* Upload Dialog Styles */
.drop-zone {
  border: 2px dashed #ccc;
  border-radius: 8px;
  padding: 40px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-bottom: 20px;
}

.drop-zone:hover {
  border-color: #1976d2;
  background-color: #f5f5f5;
}

.drop-zone.drag-over {
  border-color: #1976d2;
  background-color: #e3f2fd;
}

.file-item {
  border-left: 4px solid #1976d2;
  transition: all 0.3s ease;
}

.file-item:hover {
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.file-info {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
}

.file-details {
  flex: 1;
}

.file-original-name {
  font-weight: 500;
  word-break: break-all;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.87);
}

.status-remove-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 0;
}

.status-btn {
  min-width: 85px !important;
  font-weight: 600 !important;
}

.remove-btn {
  flex-shrink: 0;
}

/* Table row styling */
.name-cell {
  display: flex;
  align-items: center;
  font-weight: 500;
}

.name-icon {
  flex-shrink: 0;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .file-item .v-flex.md6 {
    padding-left: 0 !important;
    padding-right: 0 !important;
    margin-bottom: 16px;
  }
  
  .file-item .v-flex.md6:last-child {
    margin-bottom: 0;
  }
}

/* Global Search Styling */
.global-search-toolbar {
  background-color: #f8f9fa !important;
  border-bottom: 1px solid #e9ecef !important;
}

.global-filter-menu {
  display: contents;
}

.inp-global-search {
  width: 100%;
}

.inp-global-search .v-input__control {
  min-height: 40px;
}

/* Global Search Dialog Styling */
.search-results {
  max-height: 400px;
  overflow-y: auto;
}

.search-result-item {
  cursor: pointer;
  transition: all 0.2s ease;
}

.search-result-item:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.search-result-name {
  font-weight: 500;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.87);
}

.search-result-path {
  font-size: 12px;
  margin-top: 2px;
}

.search-result-breadcrumb {
  font-size: 11px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  opacity: 0.8;
}

.search-result-breadcrumb .v-icon {
  opacity: 0.6;
}
</style>